const photoLocations = [
  { name: "CVS Pharmacy", link: "https://www.cvs.com/store-locator/", note: "Walk-in passport photos at most NC locations" },
  { name: "Walgreens", link: "https://www.walgreens.com/storelocator", note: "Appointment recommended, walk-ins accepted" },
  { name: "UPS Store", link: "https://www.theupsstore.com/tools/find-a-store", note: "Also handles overnight shipping of documents" },
  { name: "FedEx Office", link: "https://www.fedex.com/en-us/shipping/store/locator.html", note: "Photos + shipping in one stop" },
  { name: "Walmart", link: "https://www.walmart.com/store-finder", note: "Photo center at select locations" },
];

const airports = [
  { code: "CLT", name: "Charlotte Douglas International", address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208", link: "https://www.cltairport.com/" },
  { code: "RDU", name: "Raleigh-Durham International", address: "2400 John Brantley Blvd, Morrisville, NC 27560", link: "https://www.rdu.com/" },
  { code: "GSO", name: "Piedmont Triad International", address: "1000A Ted Johnson Pkwy, Greensboro, NC 27409", link: "https://www.flyfrompti.com/" },
  { code: "AVL", name: "Asheville Regional", address: "61 Terminal Dr, Fletcher, NC 28732", link: "https://www.flyavl.com/" },
  { code: "ILM", name: "Wilmington International", address: "1740 Airport Blvd, Wilmington, NC 28405", link: "https://www.flyilm.com/" },
  { code: "FAY", name: "Fayetteville Regional", address: "400 Airport Rd, Fayetteville, NC 28306", link: "https://www.flyfay.com/" },
];

const shippingOptions = [
  { name: "FedEx", locator: "https://www.fedex.com/en-us/shipping/store/locator.html", note: "Priority Overnight for document submission" },
  { name: "UPS", locator: "https://www.theupsstore.com/tools/find-a-store", note: "Next Day Air Early AM available" },
  { name: "USPS", locator: "https://tools.usps.com/find-location.htm", note: "Priority Mail Express with tracking" },
];

export default function NCStateResources() {
  return (
    <section id="resources" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">State Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            North Carolina Passport Resources
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Everything North Carolina travelers need — photo locations, shipping options, airports, vital records, and the nearest regional passport agencies.
          </p>
        </div>

        {/* Passport Photo Locations */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-camera-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Passport Photo Locations</h3>
              <p className="text-gray-400 text-xs">Find a location near you — most offer walk-in service</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {photoLocations.map((loc, i) => (
              <a
                key={i}
                href={loc.link}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group bg-[#F7F8FA] rounded-lg p-5 border border-gray-100 hover:border-[#F6C344]/40 transition-all duration-200"
              >
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-semibold text-[#1A365D] text-sm">{loc.name}</h4>
                  <div className="w-6 h-6 flex items-center justify-center text-gray-400 group-hover:text-[#F6C344] transition-colors">
                    <i className="ri-external-link-line text-sm"></i>
                  </div>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">{loc.note}</p>
              </a>
            ))}
          </div>
          <div className="mt-4 bg-[#FEF9E7] border border-[#F6C344]/20 rounded-lg p-4 flex items-start gap-3">
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-[#F6C344] text-lg"></i>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              <strong className="text-[#1A365D]">Photo requirements:</strong> 2×2 inches, white or off-white background, taken within the last 6 months. Most chain locations know the rules, but always double-check before submitting — a bad photo is the #1 reason passport applications get delayed.
            </p>
          </div>
        </div>

        {/* NC Airports */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-flight-takeoff-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Major North Carolina Airports</h3>
              <p className="text-gray-400 text-xs">International departure points — verify passport validity before booking</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {airports.map((ap, i) => (
              <a
                key={i}
                href={ap.link}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group bg-[#F7F8FA] rounded-lg p-5 border border-gray-100 hover:border-[#F6C344]/40 transition-all duration-200"
              >
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <span className="bg-[#1A365D] text-white text-xs font-bold px-2 py-0.5 rounded">{ap.code}</span>
                    <h4 className="font-semibold text-[#1A365D] text-sm">{ap.name}</h4>
                  </div>
                  <div className="w-6 h-6 flex items-center justify-center text-gray-400 group-hover:text-[#F6C344] transition-colors">
                    <i className="ri-external-link-line text-sm"></i>
                  </div>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">{ap.address}</p>
              </a>
            ))}
          </div>
        </div>

        {/* Two-column: Agency + Vital Records */}
        <div className="grid grid-cols-1 md:grid-cols-1 gap-6 mb-12">
          {/* Washington DC Regional Passport Agency */}
          <div className="bg-[#F7F8FA] rounded-lg p-7 border border-gray-100">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                <i className="ri-building-2-line text-[#1A365D] text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-base">Washington DC Passport Agency</h3>
                <p className="text-gray-400 text-xs">Closest agency for eastern & central NC (life-or-death emergencies & travel within 14 days)</p>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">600 19th St NW<br/>Washington, DC 20006</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">877-487-2778</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">Mon–Fri 8:00 AM – 3:00 PM (appointment required)</p>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200">
              <p className="text-gray-500 text-xs leading-relaxed">
                From Raleigh, Durham, and eastern North Carolina, Washington DC is approximately 4–5 hours by car via I-95. Most North Carolina travelers find that using an approved courier like Fast Passport Center is faster and more convenient than driving to DC or Atlanta.
              </p>
            </div>
          </div>

          {/* Atlanta Regional Passport Agency */}
          <div className="bg-[#F7F8FA] rounded-lg p-7 border border-gray-100">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                <i className="ri-building-2-line text-[#1A365D] text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-base">Atlanta Passport Agency</h3>
                <p className="text-gray-400 text-xs">Closest agency for western NC (life-or-death emergencies & travel within 14 days)</p>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">230 Peachtree St NW, Suite 1000<br/>Atlanta, GA 30303</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">877-487-2778</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">Mon–Fri 8:00 AM – 3:00 PM (appointment required)</p>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200">
              <p className="text-gray-500 text-xs leading-relaxed">
                From Charlotte and the western Piedmont, Atlanta is approximately 3.5–4 hours by car via I-85. Most North Carolina travelers find that using an approved courier like Fast Passport Center is faster and more convenient than driving to Atlanta or DC.
              </p>
            </div>
          </div>

          {/* NC Vital Records */}
          <div className="bg-[#F7F8FA] rounded-lg p-7 border border-gray-100">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                <i className="ri-file-list-3-line text-[#1A365D] text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-base">North Carolina Vital Records</h3>
                <p className="text-gray-400 text-xs">Birth certificates for passport applications</p>
              </div>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              First-time passport applicants need a certified birth certificate. North Carolina birth records can be ordered online, by mail, or in person through the NC Department of Health and Human Services — Vital Records office in Raleigh.
            </p>
            <a
              href="https://www.ncdhhs.gov/divisions/public-health/vital-records"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Order NC Birth Certificate <i className="ri-external-link-line"></i>
            </a>
            <div className="mt-4 pt-4 border-t border-gray-200 space-y-2">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">Standard processing 6–8 weeks; rush available — typically 2–3 weeks</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-money-dollar-circle-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">$24 per certified copy + shipping and service fees</p>
              </div>
            </div>
          </div>
        </div>

        {/* Shipping Options */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-truck-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Shipping & Document Delivery</h3>
              <p className="text-gray-400 text-xs">Overnight options for getting documents to the processing center fast</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {shippingOptions.map((ship, i) => (
              <a
                key={i}
                href={ship.locator}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group bg-[#F7F8FA] rounded-lg p-5 border border-gray-100 hover:border-[#F6C344]/40 transition-all duration-200"
              >
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-semibold text-[#1A365D] text-sm">{ship.name}</h4>
                  <div className="w-6 h-6 flex items-center justify-center text-gray-400 group-hover:text-[#F6C344] transition-colors">
                    <i className="ri-external-link-line text-sm"></i>
                  </div>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">{ship.note}</p>
              </a>
            ))}
          </div>
        </div>

        {/* Bottom tip */}
        <div className="bg-[#0F2240] rounded-lg p-6 md:p-8 text-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 mx-auto mb-4">
            <i className="ri-lightbulb-line text-[#F6C344] text-xl"></i>
          </div>
          <h4 className="font-bold text-white text-base mb-2">Pro Tip for North Carolina Travelers</h4>
          <p className="text-white/70 text-sm max-w-2xl mx-auto leading-relaxed">
            North Carolina is home to major military installations including Fort Liberty (formerly Fort Bragg), Camp Lejeune, MCAS Cherry Point, and Seymour Johnson AFB — creating constant demand for emergency and expedited passport services for deployments and overseas assignments. The busiest passport months in NC are May through August (summer travel, beach season, and PCS moves) and November through January (holiday travel). If your trip or military orders fall during these windows, start your expedited application at least 4–6 weeks early, even with courier service.
          </p>
        </div>
      </div>
    </section>
  );
}